import birdle_desktop from "./img/birdle_desktop.png";
import birdle_mobile from "./img/birdle_mobile.png";
import birdle_icon from "./img/birdle_icon.png";
import logbook_desktop from "./img/logbook_desktop.png";
import logbook_mobile from "./img/logbook_mobile.png";
import logbook_icon from "./img/logbook_icon.png";
export const projects = [
  {
    name: "Birdle",
    id: "birdle",
    desktop: birdle_desktop,
    mobile: birdle_mobile,
    icon: birdle_icon,
    url: "https://birdle.theodoremt.com",
  },
  {
    name: "Logbook",
    id: "logbook",
    desktop: logbook_desktop,
    mobile: logbook_mobile,
    icon: logbook_icon,
    url: "https://logbook.theodoremt.com",
  },
];
